import type { WidgetWriterProps } from '../widget.type';
import { TextInput } from './textInput.writer';

export const EmailInput = (props: WidgetWriterProps) => (
  <TextInput {...props} inputType="email" />
);

export const UrlInput = (props: WidgetWriterProps) => (
  <TextInput {...props} inputType="url" />
);
